module.exports = __webpack_public_path__ + "img/FR12468.f8fc9e15.png";